// Generated by npm run icons:generate. Do not edit.
// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
import { MaterialSymbol, type MaterialIconProps } from "./material-symbol";

const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M444-630 267.79-453.79Q257-443 242.5-443t-25.98-11Q206-465 206-479.5t10.82-25.31L454.91-742.6q5.41-5.4 11.72-7.9 6.31-2.5 13.53-2.5 7.21 0 13.53 2.5Q500-748 505-743l238 238q11 11 11 25t-10.52 25q-11.48 11-26.15 11-14.66 0-25.33-11L516-630v402.02q0 15.29-10.29 25.64Q495.42-192 480.21-192t-25.71-10.34Q444-212.69 444-227.98V-630Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M440-647 244-451q-12 12-28 11.5T188-452q-11-12-11.5-28t11.5-28l264-264q6-6 13-8.5t15-2.5q8 0 15 2.5t13 8.5l264 264q11 11 11 27.5T772-452q-12 12-28.5 12T715-452L520-647v447q0 17-11.5 28.5T480-160q-17 0-28.5-11.5T440-200v-447Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M444-630 267.79-453.79Q257-443 242.5-443t-25.98-11Q206-465 206-479.5t10.82-25.31L454.91-742.6q5.41-5.4 11.72-7.9 6.31-2.5 13.53-2.5 7.21 0 13.53 2.5Q500-748 505-743l238 238q11 11 11 25t-10.52 25q-11.48 11-26.15 11-14.66 0-25.33-11L516-630v402.02q0 15.29-10.29 25.64Q495.42-192 480.21-192t-25.71-10.34Q444-212.69 444-227.98V-630Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M440-647 244-451q-12 12-28 11.5T188-452q-11-12-11.5-28t11.5-28l264-264q6-6 13-8.5t15-2.5q8 0 15 2.5t13 8.5l264 264q11 11 11 27.5T772-452q-12 12-28.5 12T715-452L520-647v447q0 17-11.5 28.5T480-160q-17 0-28.5-11.5T440-200v-447Z"
    ]
  }
} as const;

export function ArrowUpwardIcon(props: MaterialIconProps) {
  return <MaterialSymbol {...props} symbol="arrow_upward" artwork={artwork} />;
}
